import { render, staticRenderFns } from "./ItemsMenu.vue?vue&type=template&id=2f546364"
import script from "./ItemsMenu.vue?vue&type=script&lang=js"
export * from "./ItemsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports